import { EmployeeBase } from 'types';
import { jsonObjectsTexts } from 'consts/text';

export const parseEmployeeBaseIntoJsonObject: (employeeBase: EmployeeBase) => object = (
    employeeBase,
) => {
    const { firstName, lastName } = employeeBase;

    return {
        [jsonObjectsTexts.employeeBasicInfo.fields.firstname]: firstName,
        [jsonObjectsTexts.employeeBasicInfo.fields.lastname]: lastName,
    };
};
